import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './sendMessageButton.css';

interface ISendMessageButtonProps {
  noMarginTop?: boolean;
}

export const SendMessageButton = (props: React.PropsWithChildren<ISendMessageButtonProps>) => {
  const { noMarginTop, children } = props;

  return (
    <div
      className={clsx(styles['button'], {
        [styles['no-margin-top']]: noMarginTop,
      })}
    >
      {children}
    </div>
  );
};
